import {
  DoorsDefinition,
  DOORS,
  LayoutListDefinition,
  LAYOUT_LIST,
  InformationDoorDefinition,
  INFORMATION_DOOR
} from '../items';
import { Translator } from '../Translator';
import { CardHelper } from './itemHelpers/CardHelper';
import { TextHelper } from './itemHelpers/TextHelper';
import { ItemOfType } from './itemHelpers/types';
import { translate } from './translate';

export const Interactive30: Translator = sequence => {
  const doors: InformationDoorDefinition[] = [];
  // Header container (kept minimal; main instructional text will be positioned just above doors)
  const header = {
    type: LAYOUT_LIST,
    id: `${sequence.id}.list`,
    values: {
      orientation: 'column',
      padded: true,
      align: 'center'
    },
    items: []
  } as LayoutListDefinition;

  const root = translate(sequence, item => {
    if (item.__typename === 'Door') {
      doors.push({
        type: INFORMATION_DOOR,
        id: item.id,
        values: {
          id: item.id,
          linkedAudioId: item.items?.[0].audios?.[0]?.id,
          imageUrl: item.items?.[0]?.pictures?.[0]?.mediaUrl!
        },
        items: [
          CardHelper(item!.items![0] as ItemOfType<'Card'>, {
            height: '78.9%',
            // width: '25%',
            width: '374px',
            padding: '0px',
            className: 'doorsCard',
            doorId: item.id
          })
        ]
      });
    }

    if (item.__typename === 'Text') {
      header.items = [
        {
          type: LAYOUT_LIST,
          id: `${sequence.id}.list`,
          values: {
            orientation: 'column',
            align: 'top',
            padded: false
          },
          items: TextHelper(item as ItemOfType<'Text'>, { fontSize: '18px' })
        } as LayoutListDefinition
      ];
    }

    return null;
  });

  // Render the instructional text inside the doors block (as the first child)
  // so it is positioned directly above the doors instead of at the very top of
  // the slide. The doors block bottom-aligns its content when a header is present.
  root.items.push({
    type: DOORS,
    id: `${sequence.id}.carousel`,
    items: header.items.length ? [header, ...doors] : doors
  } as DoorsDefinition);

  return root;
};
